import styled, { css } from 'styled-components';
import { Button, ButtonSize, ButtonAppearance, Box } from '@bechtel/gds';
export const RequestStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  flexGrow: { sm: '1' },
  mb: { sm: '450' },
})`
  ${({ theme }) => css`
    box-shadow: 0 ${theme.spacings[100]} ${theme.spacings[200]} 0 rgba(0, 0, 0, 0.16);
    border-radius: ${theme.radii[400]};
    width: auto;
    height: 100%;
    background: ${theme.colors.white};
  `}
`;

export const ProgressWeldFooterStyled = styled(Box).attrs({
  justifyContent: { sm:'end' },
  alignItems: { sm: 'center' },
  px: { sm: '500' },
  py: { sm: '450' },
  mt: { sm: '400' },
})`
  ${({ theme }) => css`
    width: 100%;
    background: ${theme.colors.grey[100]};
    border-bottom-left-radius: ${theme.radii[400]};
    border-bottom-right-radius: ${theme.radii[400]};
  `}
`;

export const FooterButtonStyled = styled(Button).attrs({
  size: ButtonSize.MEDIUM,
  appearance: ButtonAppearance.PRIMARY,
})`
  ${({ theme }) => css`
    padding-left: ${theme.spacings[600]};
    padding-right: ${theme.spacings[600]};
    font-size: ${theme.fontSizes[500]};
    width: max-content;
  `}
`;
